import React, { useState } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import { JsonRegistroPatronal } from '../../../Helpers/JsonToOneLevel';
import ModalService from '../../../ModalService/ModalService';
import FormRegistroPatronal from './FormRegistroPatronal';

const ModalAddRegistroPatronal = ({ openAdd, setOpenAdd, agregar, errorTable, informacionAdicional, nombreModulo }) => {
    
    const [ error, setError ] = useState( null );

    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }  

    const enviarRegistroPatronal = registroPatronal => {
        const info = registroPatronal;
        Axios.post( `${servicios_grupogack_catalogo}/registropat/`, info, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    agregar( JsonRegistroPatronal(res.data.dataResponse) );
                    setOpenAdd(false);
                    break;
                default:
                    errorTable(registro_no_guardado);
                    break;
            }
        })
        .catch(error => errorTable(registro_no_guardado));
    }

    return (
        <ModalService title="Nuevo Registro Patronal" parentNode={nombreModulo}
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
            <div className="row">
                <div className="col-12">
                    <FormRegistroPatronal
                        error={error}
                        informacion={informacionAdicional}
                        enviarRegistroPatronal={enviarRegistroPatronal}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalAddRegistroPatronal;